<template>
  <div class="vote_card_container">
    
    <!-- SPONSORSHIP BOX -->
    <sponsorship-box
    v-if="contest_sponsors.length > 0"
    title="This contest sponsored by:"
    :sponsors="contest_sponsors"
    ></sponsorship-box>

    <b-button
    v-if="is_single_contest != 'true'"
    size="sm"
    variant="link"
    @click="goto_path('/vote/')"
    >
      <font-awesome-icon icon="long-arrow-alt-left"></font-awesome-icon> Full contest list
    </b-button>

    <div class="vote_card">
      
      <!-- CONTEST NAME HEADER -->
      <div class="vote_card_header">
        <div class="container">
          <div class="row">
            <div class="col-2">
              <span class="vote_card_icon_container"
              v-if="contest.icon"
              >
                <font-awesome-icon :icon="contest.icon"></font-awesome-icon>
              </span>
            </div>
            <div class="col-10">
              {{contest.label}}
            </div>
          </div>
        </div>
      </div>
      
      <!-- CONTEST IMAGE -->
      <div class="contest_image" 
      v-if="contest.lead_image"
      :style="{'background-image': 'url(\'' + resize_cms_image(contest.lead_image) + '\')' }"
      ></div>

      <transition 
      appear
      appear-class="animated pulse faster"
      appear-to-class="animated pulse faster"
      appear-active-class="animated pulse faster"
      >

        <!-- SHARE ROW -->
        <social-share-row
        v-if="is_single_contest == 'true'"
        share_type="vote"
        :contest="contest"
        ></social-share-row>

      </transition>

      <!-- SHARE BUTTON -->
      <generic-share-button
      v-if="is_single_contest != 'true'"
      @generic_share_clicked="handle_share_click"
      ></generic-share-button>
      
      <!-- CONTESTANT LIST -->
      <contestant-list-with-out-images
      v-if="contest.has_voted == false"
      :contestants="contestants"
      @contestant_selected="handle_contestant_selected"
      ></contestant-list-with-out-images>

      <!-- "ALREADY VOTED" MESSAGING -->
      <div class="already_voted_container"
      v-if="contest.has_voted == true"
      >
        <p>
          <strong>Thank you</strong> for voting on this contest today!
        </p>

        <p>
          You'll be able to <strong>vote</strong> on this contest once <strong>each day</strong> during the voting period, so come back <strong>everyday</strong> to help your favorites win.
        </p>

        <p>
          Don't forget to <strong>SHARE</strong> this contest (using the buttons above) to let others know they can vote too!
        </p>
      </div>

      <!-- STICKY BUTTON ROW FOR VOTING -->
      <fixed-vote-button-row
      :vote_enabled="vote_enabled"
      :vote_status="vote_status"
      :total_contests="master_contest_list.length"
      :voted_count="voted_count"
      :is_single_contest="is_single_contest"
      @contest_vote_submitted="handle_vote"
      @skip_vote="skip_vote"
      ></fixed-vote-button-row>

    </div>

  </div>
</template>

<script>
import ContestantListWithOutImages from '@/features/vote/ContestantListWithOutImages.vue';
import FixedVoteButtonRow from '@/features/vote/fixed_vote_card_button_row.vue';
import SocialShareRow from '@/components/social/social_share_row.vue';
import GenericShareButton from '@/components/social/generic_share_button.vue';
import SponsorshipBox from '@/features/sponsorships/sponsorship_box.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faUtensils, 
  faShoppingCart, 
  faSmileBeam,
  faTaxi,
  faUsers,
  faBowlingBall,
  faFilm,
  faShoppingBasket,
  faSwimmer,
  faMapMarkedAlt,
  faCaretRight,
  faCaretDown,
  faEnvelopeSquare,
  faLongArrowAltRight,
  faLongArrowAltLeft
} from '@fortawesome/free-solid-svg-icons';
import { 
  faFacebookSquare,
  faTwitterSquare
} from '@fortawesome/free-brands-svg-icons';
library.add(
  faUtensils, 
  faShoppingCart, 
  faSmileBeam,
  faTaxi,
  faUsers,
  faBowlingBall,
  faFilm,
  faShoppingBasket,
  faSwimmer,
  faMapMarkedAlt,
  faCaretRight,
  faCaretDown,
  faFacebookSquare,
  faTwitterSquare,
  faEnvelopeSquare,
  faLongArrowAltRight,
  faLongArrowAltLeft
);

export default {
  name: 'VoteCard',
  props: [
    'contest',
    'instance_contestid',
    'contestants',
    'vote_complete',
    'is_single_contest'
  ],
  data () {
    return {
      vote_enabled: false,
      selected_contestant: {},
      vote_status: 'idle'
    }
  },
  mounted() {
    let vm = this;

    // GET CONTEST SPONSORS
    vm.$root.store.contests.get_contest_sponsors(this.instance_contestid);

    // UPDATE COUNT OF VOTES FOR USER
    if(this.$root.store.voting.get_voted_count() == 0) {
      vm.$root.store.voting.get_contest_list_by_type(vm.instanceid, 'unvoted', vm.user_publicid)
        .then(function(response) {
          // ADJUST LIST TO BE ARRAY OF VALUES INSTEAD OF OBJECTS
          let new_list = [];
          let old_list = response.data.data;
          for(var key in old_list) {
            new_list.push(old_list[key].instance_contestid);
          }
          
          vm.$root.store.voting.store_unvoted_contest_list(new_list);
        })
        .then(function() {
          let vote_count = vm.calc_voted_count(vm.master_contest_list.length, vm.unvoted_contest_list.length);
          vm.$root.store.voting.store_voted_count(vote_count);
        })
    }
    
  },
  watch: {
    vote_complete: function(new_val, old_val) {
      if(new_val == true) {
        this.$set(this, 'vote_status', 'complete');
      }
    },
    instance_contestid: function(new_val, old_val) {
      this.$root.store.contests.get_contest_sponsors(new_val);
      return true;
    },
  },
  computed: {
    contest_sponsors: function() {
      let vm = this;
      let sponsors = this.$root.store.contests.get_current_contest_sponsors(vm.instance_contestid);
      
      return sponsors;
    },
    master_contest_list: function() {
      return this.$root.store.contests.get_current_master_contest_list();
    },
    unvoted_contest_list: function() {
      return this.$root.store.voting.get_current_unvoted_contest_list();
    },
    voted_count: function() {
      return this.$root.store.voting.get_voted_count();
    },
    user_publicid: function() {
      return this.$root.store.session.get_userid();
    },
    instanceid: function() {
      return this.$root.store.instances.get_current_instanceid();
    },
  },
  methods: {
    calc_voted_count: function(total_contest_count, unvoted_contest_count) {
      return parseInt(total_contest_count) - parseInt(unvoted_contest_count);
    },
    handle_contestant_selected: function(selected_contestant) {
      this.$set(this, 'selected_contestant', selected_contestant);
      this.$set(this, 'vote_status', 'ready');
      this.vote_enabled = true;
    },
    handle_vote: function() {
      let vm = this;

      if(typeof vm.selected_contestant.finalistid != 'undefined') {
        // ADD CONTEST LABEL FOR TRACKING
        vm.selected_contestant.contest_label = vm.contest.label;
        // vm.$emit('next_contest_requested', '');
        vm.$set(vm, 'vote_status', 'processing');
        vm.$emit('contest_vote_submitted', vm.selected_contestant);
      }
      
    },
    skip_vote: function() {
      let vm = this;

      // FIRE GA EVENT
      vm.$ga.event({
        eventCategory: 'Vote Skips',
        eventAction: 'skipped',
        eventLabel: vm.contest.label
      })

      vm.$emit('next_contest_requested', '');
    },
    resize_cms_image: function(value) {
      if(value.indexOf('/rw/') > 0) {
        return value.replace(/\/rw\//g, '/rf/image_md/');
      }
      else {
        return value;
      }
    },
    handle_share_click: function() {
      // GOTO SINGLE VOTE PAGE
      this.goto_path_with_param('/votenow/', this.instance_contestid);
    },
    goto_path: function(path_name) {
      this.$root.store.goto_path(path_name);
    },
    goto_path_with_param: function(path_name, param) {
      this.$root.store.goto_path(path_name, param);
    }
  },
  filters: {
    
  },
  components: {
    ContestantListWithOutImages,
    SocialShareRow,
    FixedVoteButtonRow,
    SponsorshipBox,
    GenericShareButton
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/styles/global_styles.scss';

.vote_card {
  margin: 1em;
  box-shadow: 1px 1px 10px 0px #aaa;
  /*padding-bottom: 1em;*/

  .vote_card_header {
    background: $dcom-purple;
    color: #FFF;
    font-size: 1.4em;
    padding: 0.5em 0;
    border-bottom: solid 4px #916c96;
  }

  .contest_image {
    width: 100%;
    height: 150px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    /*margin-bottom: 1em;*/
  }

  .vote_card_button_row {
    text-align: center;

    .btn_skip_vote {
      text-transform: uppercase;
      margin-bottom: 1em;
      font-size: 1.4em;
      margin-top: 1em;
    }
  }

  .already_voted_container {
    padding: 1em;
  }
  
}


</style>


// WEBPACK FOOTER //
// src/features/vote/vote_card.vue